// extracted by mini-css-extract-plugin
module.exports = {"spinner-overlay":"SpinnerOverlay_spinner-overlay__mhUJk","spinner-container":"SpinnerOverlay_spinner-container__7Dp_z"};